module.exports = __webpack_public_path__ + "img/banner-tc2-m.2e82f53c.jpg";